import QueuedTasksTypes from './queuedTasks.types';
import { QuickReplyText, ProcessStatuses } from './queuedTasks.state';
import { ICallContactAttributes } from '../contact/contact.state';

export type QueuedTasksAction =
    | {
        type: typeof QueuedTasksTypes.SET_QUICK_REPLY_RICH_TEXT;
        payload: QuickReplyText;
    }
    | {
        type: typeof QueuedTasksTypes.SET_QUICK_REPLY_PLAIN_TEXT;
        payload: QuickReplyText;
    }
    | {
        type: typeof QueuedTasksTypes.UPDATE_ACW_ATTRIBUTES_QUEUED_TASKS;
        payload: { acwAttributes: ICallContactAttributes; IDs: string[] };
    }
    | { type: typeof QueuedTasksTypes.CLEAR_ACW_ATTRIBUTES_QUEUED_TASKS }
    | {
        type: typeof QueuedTasksTypes.SET_QUEUED_TASK_PROCESSING;
        payload: boolean;
    }
    | {
        type: typeof QueuedTasksTypes.SET_QUEUED_TASK_PROCESSING_SHOW_MODAL;
        payload: boolean;
    }
    | {
        type: typeof QueuedTasksTypes.SET_QUEUED_TASK_PROCESSING_CONTACTS;
        payload: string[];
    }
    | {
        type: typeof QueuedTasksTypes.SET_QUEUED_TASK_PROCESSING_STATUSES;
        payload: ProcessStatuses;
    }

export function setQueuedTasksReplyText(type: string, text: string, isProbablyJson: boolean): QueuedTasksAction {
    return {
        type:
            type === 'plain' ? QueuedTasksTypes.SET_QUICK_REPLY_PLAIN_TEXT : QueuedTasksTypes.SET_QUICK_REPLY_RICH_TEXT,
        payload: {
            text,
            isProbablyJson,
        },
    };
}

export function updateACWAttributesQueuedTasks(IDs: string[], acwAttributes: ICallContactAttributes) {
    return {
        type: QueuedTasksTypes.UPDATE_ACW_ATTRIBUTES_QUEUED_TASKS,
        payload: { acwAttributes, IDs },
    };
}

export function clearACWAttributesQueuedTasks() {
    return { type: QueuedTasksTypes.CLEAR_ACW_ATTRIBUTES_QUEUED_TASKS };
}

export function setQueuedTasksProcessing(isProcessing: boolean): QueuedTasksAction {
    return {
        type: QueuedTasksTypes.SET_QUEUED_TASK_PROCESSING,
        payload: isProcessing,
    };
}

export function setQueuedTasksProcessingShowModal(isShow: boolean): QueuedTasksAction {
    return {
        type: QueuedTasksTypes.SET_QUEUED_TASK_PROCESSING_SHOW_MODAL,
        payload: isShow,
    };
}

export function setQueuedTasksProcessingContacts(contacts: string[]): QueuedTasksAction {
    return {
        type: QueuedTasksTypes.SET_QUEUED_TASK_PROCESSING_CONTACTS,
        payload: contacts,
    };
}

export function setQueuedTasksProcessStatuses(processStatuses: ProcessStatuses): QueuedTasksAction {
    return {
        type: QueuedTasksTypes.SET_QUEUED_TASK_PROCESSING_STATUSES,
        payload: processStatuses,
    };
}
